import React from 'react';
import Currency from 'react-currency-formatter';
import { useTranslation } from 'react-i18next';

// material-ui
import { TableCell, TableRow } from '@mui/material';

// Icons
import { Warning } from '@mui/icons-material';

// Styles

// Actions

import useImage from 'services/Hooks/useImage';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import ThemedTooltip from '@acnb/CustomComponents/Tooltip/ThemedTooltip';
import { useAllInventoryItems } from 'services/Data/InventoryItemServices';

// Components

// Others

const DealerCopyDefaultCategorySection = ({
  categoryLabel,
  projectInventoryItems,
  headerColSpan,
  projectCurrency,
  setWarningModalInfo,
}) => {
  const { t } = useTranslation();
  const { getInventoryItemImage } = useImage();
  const { descriptionReference, warningReference, warningReferenceFallback } = useLanguageReference();

  const { data: availableInventoryItems } = useAllInventoryItems();

  return (
    <>
      <TableRow>
        <TableCell colSpan={headerColSpan} style={{ backgroundColor: '#c9c7c7' }}>
          <strong>{categoryLabel}</strong>
        </TableCell>
      </TableRow>
      {projectInventoryItems
        ?.filter(projectInventoryItem => projectInventoryItem.quantity)
        ?.map(projectInventoryItem => {
          let inventoryItem = availableInventoryItems?.find(as => as.id === projectInventoryItem.inventoryItem_Id);
          return (
            <TableRow key={projectInventoryItem.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell>
                {projectInventoryItem?.files?.length > 0 && (
                  <img
                    src={getInventoryItemImage(projectInventoryItem?.inventoryItem_Id, projectInventoryItem?.files[0].id)}
                    alt={t('InventoryItemImage')}
                    style={{
                      maxHeight: '50px',
                      width: '100%',
                      objectFit: 'contain',
                    }}
                  />
                )}
              </TableCell>
              <TableCell>
                {(inventoryItem?.[warningReference] || inventoryItem?.[warningReferenceFallback]) && (
                  <ThemedTooltip
                    title={inventoryItem?.[warningReference] || inventoryItem?.[warningReferenceFallback]}
                    placement={'top'}>
                    <Warning
                      color="warning"
                      style={{ cursor: 'pointer' }}
                      sx={{ mr: 1 }}
                      onClick={() => {
                        setWarningModalInfo({ open: true, inventoryItem });
                      }}
                    />
                  </ThemedTooltip>
                )}
                <strong>{`${inventoryItem?.sku}`}</strong>
              </TableCell>
              <TableCell>{inventoryItem?.[descriptionReference]}</TableCell>
              <TableCell align="center">{projectInventoryItem.quantity || '0'}</TableCell>
              <TableCell align="right">
                {projectInventoryItem.projectDealerUnitPrice === 0 ? (
                  '-'
                ) : (
                  <Currency quantity={projectInventoryItem.projectDealerUnitPrice} currency={projectCurrency} />
                )}
              </TableCell>
              <TableCell align="right">
                {projectInventoryItem.projectDealerTotalPrice === 0 ? (
                  '-'
                ) : (
                  <Currency quantity={projectInventoryItem.projectDealerTotalPrice} currency={projectCurrency} />
                )}
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          );
        })}
    </>
  );
};

export default DealerCopyDefaultCategorySection;
